<template>
    <router-view></router-view>
    <Toast />
</template>
